/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * SwitchHRSystemIcon - Auto-generated from icon.js
 */
export const SwitchHRSystemIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M13.7871 1.66699L16.8174 4.6973L13.7871 7.7276" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M3.18164 9.24272V7.72757C3.18164 6.92388 3.5009 6.15311 4.0692 5.58482C4.63749 5.01653 5.40826 4.69727 6.21194 4.69727H16.818" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6.21194 18.3331L3.18164 15.3028L6.21194 12.2725" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M16.818 10.7578V12.273C16.818 13.0767 16.4987 13.8474 15.9304 14.4157C15.3622 14.984 14.5914 15.3033 13.7877 15.3033H3.18164" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default SwitchHRSystemIcon;
